import { useEffect, useState } from 'react';
import { t, tf } from './lib/i18n';

export function RecoveryNotice({ interrupted, preserved = t('YOUR PROGRESS IS SAFE') }: {
  interrupted: boolean; preserved?: string;
}) {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!interrupted) { setLevel(0); return; }
    const reconnecting = window.setTimeout(() => setLevel(1), 700);
    const holding = window.setTimeout(() => setLevel(2), 4_500);
    const stopped = window.setTimeout(() => setLevel(3), 15_000);
    return () => { window.clearTimeout(reconnecting); window.clearTimeout(holding); window.clearTimeout(stopped); };
  }, [interrupted]);

  if (!interrupted || level === 0) return null;
  const copy = level === 1 ? t('RECONNECTING…')
    : level === 2 ? tf('CONNECTION INTERRUPTED · {preserved}', { preserved })
      : tf('COULDN’T RECONNECT · {preserved}', { preserved });
  return <p className={`connection-pill recovery-level-${level}`} role="status" aria-live="polite">{copy}</p>;
}

